import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';

import { FileUpload } from 'styled-icons/fa-solid/FileUpload';
import { Plus } from 'styled-icons/boxicons-regular/Plus';

import { Button, FlexView, Row } from '@cuemath/comps';

import { Message } from 'modules/form';
import { getAll as getRelationshipManagers } from 'actions/relationship-manager';
import { openModal } from 'actions/modal';
import { FORM_ACTIONS, MODAL_FORM } from 'constants/form';
import MODAL from 'constants/modal';

import ParentRelationshipManagers from './list';

const FullFlexView = styled(FlexView)`
  width: 100%;
`;
const Head = styled(Row)`
  padding-left: 20px;
  padding-bottom: 20px;
  margin-right: auto;
`;
const HeaderButton = styled(Button)`
  margin-left: 10px;
`;

class ParentRelationshipManagersTab extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      listData: {},
    };
  }

  static getDerivedStateFromProps({ relationshipManagers, actions }) {
    const rmList = store.getAll(relationshipManagers);
    const isListStale = !!(rmList && rmList.isStale);

    if (isListStale) actions.getRelationshipManagers();
    return {
      listData: rmList,
    };
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.getRelationshipManagers();
  }

  postUpload = status => {
    this.setState({ uploadStatus: status || 'failed' });
  };

  onPageChange = newPage => {
    this.setState({ page: newPage });
  };

  openCreateRMForm = ({ formType, data }) => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.RM_FORM,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType, data },
    );
  };

  uploadRMAssignment = () => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.BULK_RM_ASSIGNMENT_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { postUpload: this.postUpload, modalType: 'rm_assignment' },
    );
  };

  uploadRMBulkUpdate = () => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.BULK_RM_ASSIGNMENT_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { postUpload: this.postUpload, modalType: 'bulk_rm_update' },
    );
  };

  render() {
    const {
      listData: { data: rmList = [] },
      uploadStatus,
    } = this.state;

    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <Head>
          <HeaderButton
            label="Create RM"
            icon={Plus}
            disabled={!(rmList && rmList.length > 0)}
            onClick={() =>
              this.openCreateRMForm({
                formType: FORM_ACTIONS.CREATE,
                data: {
                  managersList: rmList.filter(
                    item => item.role_title === 'Parent RM Manager',
                  ),
                },
              })
            }
          />
          <HeaderButton
            label="RM Bulk Assignment"
            icon={FileUpload}
            disabled={!(rmList && rmList.length > 0)}
            onClick={() => this.uploadRMAssignment()}
          />
          <HeaderButton
            label="RM Bulk Update"
            icon={FileUpload}
            disabled={!(rmList && rmList.length > 0)}
            onClick={() => this.uploadRMBulkUpdate()}
          />
          {uploadStatus && (
            <Message error={uploadStatus !== 'success'}> Upload {uploadStatus}</Message>
          )}
        </Head>
        <ParentRelationshipManagers tableData={rmList} />
      </FullFlexView>
    );
  }
}

export default connect(
  ({ relationshipManagers }) => ({ relationshipManagers }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getRelationshipManagers,
        openModal,
      },
      dispatch,
    ),
  }),
)(ParentRelationshipManagersTab);
